import { jsx as _jsx } from "react/jsx-runtime";
import GenericSettingsPage from './GenericSettingsPage';
const DoorModelGroupsPage = () => {
    const columns = [
        { key: 'name', label: 'Name', type: 'text', required: true },
        { key: 'description', label: 'Description', type: 'text' },
        { key: 'sort_order', label: 'Sort Order', type: 'number', min: 0 },
    ];
    return (_jsx(GenericSettingsPage, { tableName: "door_model_groups", title: "Door Models", columns: columns, apiPath: "door_model_groups" }));
};
export default DoorModelGroupsPage;
